const MinusSmallIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13 10H7" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" />
  </svg>
);

export { MinusSmallIcon };
